import React from 'react';

import styles from './CMSIFrame.scss';

export interface Props {
  url: string;
  title: string;
}

const CMSIFrame: React.FunctionComponent<Props> = ({ url, title }) => (
  <iframe title={title} src={url} className={styles.casinoIFrame} frameBorder="0" scrolling="yes" />
);

export default CMSIFrame;
